export const languages = [
    {
        code: 'es',
        label: 'ES',
        enable: true
    },
    {
        code: 'en',
        label: 'EN',
        enable: true
    }
];
